var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9465 3.91052L13.4818 11.4293C13.363 13.3503 13.3036 14.3108 12.8221 15.0014C12.584 15.3428 12.2776 15.631 11.9221 15.8475C11.2031 16.2855 10.2408 16.2855 8.31606 16.2855C6.38887 16.2855 5.42526 16.2855 4.70582 15.8467C4.35013 15.6298 4.04353 15.3411 3.80554 14.9991C3.32419 14.3075 3.26612 13.3456 3.14999 11.4219L2.69653 3.91052",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57153 3.91071H15.0715M11.3633 3.91071L10.8514 2.8545C10.5112 2.1529 10.3411 1.8021 10.0478 1.58331C9.98278 1.53478 9.91386 1.49161 9.84178 1.45423C9.51696 1.28571 9.12711 1.28571 8.34741 1.28571C7.54813 1.28571 7.14853 1.28571 6.81829 1.4613C6.74511 1.50021 6.67527 1.54513 6.6095 1.59558C6.31276 1.82323 6.14701 2.18687 5.81549 2.91415L5.36122 3.91071",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44653 12.1606V7.66058",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1965 12.1606V7.66058",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9fb7ca79a719021735ecdbbea4eb0cf1.svg";
export { ForwardRef as ReactComponent };